<template>
  <el-select
    v-model="serieModel"
    @change="serieChanged"
    :placeholder="$t('ESTIMATE_VEHICLES.SERIES')"
    :filterable="filterable"
    :disabled="disabled"
    :loading="loading"
  >
    <el-option
      v-if="allowNone"
      :value="null"
      :label="$t('ESTIMATE_VEHICLES.SERIES')"
    />
    <el-option
      v-for="serie in series"
      :key="serie.value"
      :value="serie.value"
      :label="serie.label"
    >
    </el-option>
  </el-select>
</template>

<script>
import _ from "lodash";
import { Option, Select } from "element-ui";

export default {
  name: "serie-selector",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
      description: "Disable the input",
    },
    filterable: {
      type: Boolean,
      default: true,
      description: "Can filter",
    },
    year: {
      type: Number | String | null,
      default: null,
      description: "Year",
    },
    make: {
      type: String | null,
      default: null,
      description: "Make",
    },
    model: {
      type: String | null,
      default: null,
      description: "Model",
    },
    value: {
      type: String | Number | null | undefined,
      default: "",
      description: "Value",
    },
    allowNone: {
      type: Boolean,
      default: false,
      description: "Show the option none",
    },
  },

  data() {
    const serieModel = this.value?.toLowerCase();
    return {
      serieModel,
      series: [],
    };
  },

  setup() {},

  created() {
    this.getSeries();
  },

  methods: {
    getListDebounced: _.debounce(function () {
      this.getSeries();
    }, 300),

    async getSeries() {
      try {
        this.loading = true;
        let params = {
          sort: "name",
          filter: {},
        };
        if (this.year) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              year: this.year,
            },
          };
        }

        if (this.make) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              vmake: this.make,
            },
          };
        }

        if (this.model) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              model: this.model,
            },
          };
        }

        await this.$store.dispatch("estimateVehicleSerie/list", params);
        const seriesArr = await this.$store.getters[
          "estimateVehicleSerie/list"
        ];
        this.series = [];
        let tempArr = [];
        seriesArr.forEach((serie) => {
          if (!tempArr.includes(serie.name?.toLowerCase())) {
            tempArr.push(serie.name?.toLowerCase());
            this.series.push({
              value: serie.name?.toLowerCase(),
              label: serie.name,
            });
          }
        });
        if (!tempArr.includes(this.serieModel?.toLowerCase())) {
          this.serieModel = "";
          this.serieChanged("");
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      } finally {
        this.loading = false;
      }
    },

    serieChanged(serie) {
      this.$emit("serieChanged", serie);
    },
  },

  watch: {
    year: {
      handler: "getListDebounced",
      immediate: true,
    },
    make: {
      handler: "getListDebounced",
      immediate: true,
    },
    model: {
      handler: "getListDebounced",
      immediate: true,
    },
    value() {
      this.serieModel = this.value?.toLowerCase();
    },
  },
};
</script>
